import React, { useState, useEffect } from 'react';
import './App.css';
import YC from './assets/YCombinatorLogo.svg';
import { PiArrowCircleRightFill } from 'react-icons/pi';
import b2bDashBoardHero from './assets/business/b2bDashBoardHero.svg';
import b2bDashBoardHeroSmall from './assets/business/b2bDashBoardHeroSmall.svg';
import { AppImages } from './assets/s3';
import { businessFAQs } from './constants/data';
import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';
import SignUpNowModal from './components/modals/signUpNowModal';
import b2bBg from './assets/business/b2bBg.png';
import { redirect, logAnalytics } from './util';
import { RedirectURLs } from './constants/redirectURLS';
import SeoComponent from './components/seoComponent';

export default function CypherBusiness() {
  const [showModal, setShowModal] = useState(false);
  const [expandedIndex, setExpandedIndex] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleFAQ = (index) => {
    if (index === expandedIndex) {
      setExpandedIndex(null);
    } else {
      setExpandedIndex(index);
    }
  };

  return (
    <>
      <SeoComponent page={window.location.pathname} />
      <div className='bg-white overflow-none'>
        <SignUpNowModal showModal={showModal} setShowModal={setShowModal} />
        <div>
          <div class='flex flex-col items-center justify-center w-full'>
            <div
              class={'bg-cover bg-center h-full w-full relative'}
              style={{ backgroundImage: `url("${b2bBg}")` }}
            >
              <div class='w-full px-5 leading-10 lg:mx-auto text-left lg:text-center mt-[136px] lg:mt-[187px]'>
                <div className='mb-4'>
                  <div class='text-[28px] md:text-5xl lg:text-6xl font-bold text-gray-700'>
                    Financial <br className='block md:hidden' />
                    <span className='text-[#FFB900]'>Operating System</span>
                  </div>
                  <div className='text-[28px] md:text-4xl lg:text-5xl font-semibold text-gray-700 md:mt-2 lg:mt-4'>
                    For Web3 Teams
                  </div>
                </div>
                <div className='text-sm lg:text-base  font-normal text-[#7F7F7F]'>
                  Manage Card Spend & Pay Vendors, Contractors, and Employees
                  Directly
                  <br /> from Your Gnosis Safe or Ledger. Built for Web3 Teams &
                  DAOs.
                </div>
                <div className='mt-6 w-full flex items-center lg:justify-center lg:m-0 space-x-4 mt-3'>
                  <p className='font-medium text-base'>{'Backed by'}</p>
                  <img
                    src={YC}
                    className='w-[88px] md:w-[120px] ml-1.5'
                    alt='YC_Logo'
                  />
                </div>
                <div className='flex flex-row items-center lg:justify-center mt-4 lg:mt-10'>
                  {/* <button
                  className='flex flex-row items-center justify-center bg-[#EBEDF0] py-[13.5px] lg:py-2.5 px-[45px] lg:px-7 rounded-full mr-4 cursor-pointer'
                  onClick={() =>
                    window.open('https://calendly.com/growth-cypherhq')
                  }
                >
                  <p className='text-xs lg:text-md font-bold'>Book Demo</p>
                </button> */}
                  <button
                    className='hidden min-[542px]:block flex flex-row items-center justify-center bg-[#EBEDF0] py-[13.5px] lg:py-2.5 px-[45px] lg:px-7 rounded-full mr-4 cursor-pointer'
                    onClick={() => {
                      window.open('https://business.cypherhq.io/?isDemo=true');
                      logAnalytics({
                        category: 'business',
                        action: 'click link to demo',
                        label: 'try it now',
                      });
                    }}
                  >
                    <p className='text-xs lg:text-md font-bold'>
                      👀 Try it now
                    </p>
                  </button>
                  <button
                    className='flex flex-row items-center justify-center bg-[#FFB900] py-2.5 px-7 rounded-full cursor-pointer'
                    onClick={() => {
                      redirect(RedirectURLs.businessSignup);
                      logAnalytics({
                        category: 'business',
                        action: 'click link to business signup page',
                        label: 'signup now',
                      });
                    }}
                  >
                    <p className='text-xs lg:text-md font-bold'>Signup Now</p>
                    <PiArrowCircleRightFill className='block lg:hidden w-6 h-6 ml-1.5' />
                  </button>
                </div>
              </div>
              <div className='hidden md:block md:mt-[94px] md:w-full md:flex md:flex-col md:items-center md:px-4'>
                <img
                  src={b2bDashBoardHero}
                  className='w-[1156px] max-h-[475px]'
                />
              </div>
              <div className='block md:hidden w-full flex flex-col items-end'>
                <img
                  src={b2bDashBoardHeroSmall}
                  className='min-w-[332px] min-h-[284px]'
                />
              </div>
              <div className='block min-[542px]:hidden flex flex-col items-center w-full mb-8'>
                <p className='text-sm font-medium mb-3'>
                  Experience Cypher now
                </p>
                <button
                  className='flex flex-row items-center justify-center bg-[#EBEDF0] py-[13.5px] lg:py-2.5 px-[45px] lg:px-7 rounded-full cursor-pointer'
                  onClick={() => {
                    window.open('https://business.cypherhq.io/?isDemo=true');
                    logAnalytics({
                      category: 'business',
                      action: 'click link to demo',
                      label: 'try it now',
                    });
                  }}
                >
                  <p className='text-xs lg:text-md font-bold'>👀 Try it now</p>
                </button>
              </div>
            </div>
          </div>
          <div className='w-full flex flex-col items-center justify-center bg-[#141414] py-6 px-6 lg:py-[100px] mt-[-12px]'>
            <div className='max-w-[920px] flex flex-col lg:flex-row justify-between'>
              <div className='lg:mr-[67px]'>
                <p
                  className='text-2xl lg:text-[40px] font-bold leading-[35px] lg:leading-[58px]'
                  style={{
                    background:
                      'linear-gradient(to bottom, #F6F7FB ,90%,  #765600)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                >
                  Manage Your Team Finance <br />
                  Directly from Your <br />
                  Gnosis Safe or Ledger
                </p>
              </div>
              <div className='flex flex-col items-start lg:items-end mt-2 lg:mt-0'>
                <p className='text-base font-normal lg:text-end text-[#999999]'>
                  Streamline your financial management
                  <br /> effortlessly with our intuitive tools and <br />{' '}
                  user-friendly solutions.
                </p>
                <div className='mt-6'>
                  <div
                    className='flex flex-row items-center justify-center bg-[#FFB900] py-2.5 px-7 rounded-full cursor-pointer'
                    onClick={() => {
                      window.open('https://calendly.com/growth-cypherhq');
                      logAnalytics({
                        category: 'business',
                        action: 'click link to book demo calendly',
                        label: 'book demo',
                      });
                    }}
                  >
                    <p className='text-md font-bold'>Book Demo</p>
                  </div>
                </div>
              </div>
            </div>
            <div className='hidden lg:block lg:max-w-[920px] lg:flex lg:flex-row lg:justify-between lg:mt-[100px]'>
              <div
                className='w-[290px] h-[202px] flex flex-col items-center rounded-[12px] mr-6'
                style={{
                  background:
                    'linear-gradient(-135deg, #191919 25%, #30291B 100%)',
                }}
              >
                <img
                  src={AppImages.FUND_CONTROL_ICON}
                  className='w-[51px] h-[51px] mt-6'
                />
                <p className='tracking-tight font-bold text-[#ffffff] mt-5'>
                  Spend Control
                </p>
                <p className='text-xs text-center px-6 text-[#BEBDC2] mt-2.5'>
                  Empower your team with control over funds, allowing for secure
                  and transparent collaboration on financial decisions.
                </p>
              </div>
              <div
                className='w-[290px] h-[202px] flex flex-col items-center rounded-[12px] mr-6'
                style={{
                  background:
                    'linear-gradient(-135deg, #191919 25%, #30291B 100%)',
                }}
              >
                <img
                  src={AppImages.ANALYTICS_ICON}
                  className='w-[51px] h-[51px] mt-6'
                />
                <p className='tracking-tight font-bold text-[#ffffff] mt-5'>
                  Advanced Analytics
                </p>
                <p className='text-xs text-center px-6 text-[#BEBDC2] mt-2.5'>
                  Gain insights into team finances with advanced analytics,
                  enabling data-driven decisions.
                </p>
              </div>
              <div
                className='w-[290px] h-[202px] flex flex-col items-center rounded-[12px]'
                style={{
                  background:
                    'linear-gradient(-135deg, #191919 25%, #30291B 100%)',
                }}
              >
                <img
                  src={AppImages.CARD_ICON}
                  className='w-[51px] h-[51px] mt-6'
                />
                <p className='tracking-tight font-bold text-[#ffffff] mt-5'>
                  Track and pay expense
                </p>
                <p className='text-xs text-center px-6 text-[#BEBDC2] mt-2.5'>
                  Stay on top of team spending and simplify payments with ease.
                </p>
              </div>
            </div>

            <div className='block lg:hidden flex flex-col mt-[42px]'>
              <div className='flex flex-col'>
                <img
                  src={AppImages.FUND_CONTROL_ICON}
                  className='w-[32px] h-[32px]'
                />
                <p className='tracking-tight font-bold text-[#ffffff] mt-2'>
                  Fund Control
                </p>
                <p className='text-xs text-left text-[#BEBDC2] mt-1.5'>
                  Empower your team with control over funds, allowing for
                  <br /> secure and transparent collaboration on financial
                  <br /> decisions.
                </p>
              </div>
              <div className='flex flex-col mt-6'>
                <img
                  src={AppImages.ANALYTICS_ICON}
                  className='w-[32px] h-[32px]'
                />
                <p className='tracking-tight font-bold text-[#ffffff] mt-2'>
                  Advanced Analytics
                </p>
                <p className='text-xs text-left text-[#BEBDC2] mt-1.5'>
                  Gain insights into team finances with advanced
                  <br /> analytics, enabling data-driven decisions.
                </p>
              </div>
              <div className='flex flex-col mt-6 mb-6'>
                <img src={AppImages.CARD_ICON} className='w-[32px] h-[32px]' />
                <p className='tracking-tight font-bold text-[#ffffff] mt-2'>
                  Track and pay expense
                </p>
                <p className='text-xs text-left text-[#BEBDC2] mt-1.5'>
                  Stay on top of team spending and simplify payments
                  <br /> with ease.
                </p>
              </div>
            </div>
          </div>

          <div className='w-full'>
            <div
              className='invisible lg:visible w-[1px] h-full absolute top-0 left-[6%] -z-10'
              style={{
                background:
                  'linear-gradient(#A7A7A7 16%, #E8E8E8 100%, #EDEDED 100%, #DADADA 100%)',
              }}
            />
            <div
              className='invisible lg:visible w-[1px] h-full absolute top-0 right-[6%] -z-10'
              style={{
                background:
                  'linear-gradient(#B6B6B6 16%, #E8E8E8 100%, #EDEDED 100%, #DADADA 100%)',
              }}
            />

            <div className='mt-[105px]'>
              <div className='hidden lg:block w-full h-[0.5px] bg-[#ABABAB]' />
              <div className='hidden w-[86%] lg:grid grid-cols-5 mx-auto'>
                <div className='flex items-center justify-center h-[118px] border border-x-[#BCBCBC]'>
                  <img src={AppImages.TAKADOA} alt='' className='h-[30px]' />
                </div>
                <div className='flex items-center justify-center h-[118px] border border-x-[#BCBCBC]'>
                  <img src={AppImages.BENQI} alt='' className='h-[67px]' />
                </div>
                <div className='flex items-center justify-center h-[118px] border border-x-[#BCBCBC]'>
                  <img src={AppImages.TEGRO} alt='' className='h-[39px]' />
                </div>
                <div className='flex items-center justify-center h-[118px] border border-x-[#BCBCBC]'>
                  <img
                    src={AppImages.DELTA_PRIME}
                    alt=''
                    className='h-[72px]'
                  />
                </div>
                <div className='flex items-center justify-center h-[118px] border border-x-[#BCBCBC]'>
                  <img src={AppImages.SHARDEUM} alt='' className='h-[43px]' />
                </div>
              </div>

              <div className='hidden lg:block w-full h-[0.5px] bg-[#ABABAB]' />
              <div className='hidden lg:block my-[55px]'>
                <p className='text-center font-semibold text-[36px]'>
                  {'Our Valued Customers'}
                </p>
                <p className='text-center text-[#AEAEAE] font-normal text-[32px] tracking-tighter'>
                  {'Who are impressed by our products'}
                </p>
              </div>
              <div className='hidden lg:block w-full h-[0.5px] bg-[#ABABAB]' />
              <div className='hidden w-[86%] lg:grid grid-cols-4 mx-auto'>
                <div className='flex items-center justify-center h-[118px] border-x border-x-[#BCBCBC]'>
                  <img src={AppImages.BANDIT} alt='' className='h-[36px]' />
                </div>
                <div className='flex items-center justify-center h-[118px] border-x border-x-[#BCBCBC]'>
                  <img src={AppImages.WEAVE} alt='' className='h-[67px]' />
                </div>
                <div className='flex items-center justify-center h-[118px] border-x border-x-[#BCBCBC]'>
                  <img src={AppImages.GMX} alt='' className='h-[50px]' />
                </div>
                <div className='flex items-center justify-center h-[118px] border-x border-x-[#BCBCBC]'>
                  <img src={AppImages.ZEROXPPL} alt='' className='h-[62px]' />
                </div>
              </div>
              <div className='hidden lg:block w-full h-[0.5px] bg-[#ABABAB]' />

              <div className='lg:hidden w-full h-[0.5px] bg-[#ABABAB]' />
              <div className='lg:hidden grid grid-cols-3 w-[86%] mx-auto'>
                <div className='flex items-center justify-center h-[55px]'>
                  <img src={AppImages.TAKADOA} alt='' className='h-[20px]' />
                </div>
                <div className='flex items-center justify-center h-[55px] border-x border-x-[#D9D9D9] '>
                  <img src={AppImages.WEAVE} alt='' className='h-[25px]' />
                </div>
                <div className='flex items-center justify-center h-[55px]'>
                  <img src={AppImages.SHARDEUM} alt='' className='h-[23px]' />
                </div>
              </div>
              <div className='lg:hidden w-full h-[0.5px] bg-[#D9D9D9] ' />
              <div className='lg:hidden grid grid-cols-4 w-[86%] mx-auto w-full'>
                <div className=' col-span-1 w-full'>
                  <div className='flex items-center justify-center h-[80px] w-[78px] border-r border-b border-r-[#D9D9D9] border-b-[#D9D9D9]'>
                    {
                      <img
                        src={AppImages.DELTA_PRIME}
                        alt=''
                        className='h-[40px]'
                      />
                    }
                  </div>
                  <div className='flex items-center justify-center h-[80px] w-[78px] border-r border-r-[#D9D9D9]'>
                    <img src={AppImages.ZEROXPPL} alt='' className='h-[32px]' />
                  </div>
                </div>
                <div className='col-span-2 flex flex-col items-center justify-center px-[6px]'>
                  <p className='text-[20px] font-semibold'>
                    {'Our Valued Customers'}
                  </p>
                  <p className='text-[20px] font-normal text-[#AEAEAE]'>
                    {'Who are impressed by our product'}
                  </p>
                </div>

                <div className=' col-span-1 flex flex-col items-end'>
                  <div className='flex items-center justify-center h-[80px] w-[78px] border-l border-b border-l-[#D9D9D9] border-b-[#D9D9D9]'>
                    <img src={AppImages.GMX} alt='' className='h-[25px]' />
                  </div>
                  <div className='flex items-center justify-center h-[80px] w-[78px] border-l  border-l-[#D9D9D9]'>
                    <img src={AppImages.BENQI} alt='' className='h-[20px]' />
                  </div>
                </div>
              </div>
              <div className='lg:hidden w-full h-[0.5px] bg-[#D9D9D9] ' />
              <div className='lg:hidden grid grid-cols-2 w-[86%] mx-auto'>
                <div className='flex items-center justify-center h-[55px]'>
                  <img src={AppImages.BANDIT} alt='' className='h-[21px]' />
                </div>
                <div className='flex items-center justify-center h-[55px] border-l border-l-[#D9D9D9] '>
                  <img src={AppImages.TEGRO} alt='' className='h-[17px]' />
                </div>
              </div>
              <div className='lg:hidden w-full h-[0.5px] bg-[#D9D9D9] ' />
            </div>

            <div className='flex flex-col items-center lg:flex-row w-full justify-center mt-[44px] lg:mt-[150px]'>
              <div>
                <img
                  src={AppImages.CRYPTO_CARDS_BUNCH}
                  className='w-[192px] h-[219px] lg:h-[372px] lg:w-[326px]'
                />
              </div>
              <div className='flex flex-col mr-7 lg:-order-1 px-6 lg:px-0'>
                <p className='text-[24px] lg:text-[44px] font-bold tracking-tighter'>
                  Spend Crypto <span className='text-[#FFB900]'>Worldwide</span>
                  <br /> With Ease. Our Card Makes <br />
                  <span className='text-[#FFB900]'>It Possible</span>.
                </p>
                <p className='text-[#999999] mt-3 text-sm lg:text-base'>
                  Get unlimited cards for your team, both <br /> physical and
                  virtual card.
                </p>
                <div
                  className='bg-[#EBEDF0] lg:bg-[#FFB900] text-xs lg:text-base w-[149px] py-2.5 px-7 rounded-full mt-6 cursor-pointer'
                  onClick={() => {
                    window.location.href = '/card';
                    logAnalytics({
                      category: 'business',
                      action: 'click link to card static page',
                      label: 'know more',
                    });
                  }}
                >
                  <p className='text-md font-bold text-center'>Know more</p>
                </div>
              </div>
            </div>

            <div className='flex flex-col lg:flex-row w-full items-center justify-center mt-6 lg:mt-[64px]'>
              <div className='flex flex-col mx-4 lg:ml-0 lg:mr-6 '>
                <div className='flex flex-col rounded-[16px] bg-[#141414] p-6 pb-8 overflow-hidden max-w-[448px] max-h-[264px]'>
                  <p className='font-bold text-[#ffffff] tracking-tight'>
                    Individual Data Visualisation
                  </p>
                  <div className='text-[14px] text-[#999999] mt-3'>
                    Explore team expenses dynamically, fostering deeper insights{' '}
                    <br /> and informed decision-making
                  </div>
                  <div className='flex flex-row mt-6 justify-start'>
                    <img
                      src={AppImages.DATA_VISUALISATION_LEFT}
                      className='w-[181px] h-[105px] mr-3'
                    />
                    <img
                      src={AppImages.DATA_VISUALISATION_RIGHT}
                      className='w-[181px] h-[105px]'
                    />
                  </div>
                </div>
                <div className='flex flex-col rounded-[16px] bg-[#F2F3F6] mt-6 overflow-hidden border border-[#D1D1D1] max-h-[424px] max-w-[448px]'>
                  <p className='font-bold text-[#000000] tracking-tight px-6 mt-6'>
                    Expense Tracking
                  </p>
                  <div className='text-[14px] text-[#999999] mt-3 mb-[32px] px-6'>
                    Explore team expenses dynamically, fostering deeper insights{' '}
                    <br /> and informed decision-making
                  </div>
                  <div className='w-full flex flex-col items-center'>
                    <img
                      src={AppImages.EXPENSE_TRACKING}
                      className={'h-[312px] w-[420px] m-[-20px]'}
                    />
                  </div>
                </div>
              </div>
              <div className='flex flex-col mx-4 lg:mx-0'>
                <div className='flex flex-col rounded-[16px] bg-[#141414] p-6 pb-0 mt-6 overflow-hidden max-w-[448px] max-h-[264px]'>
                  <p className='font-bold text-[#ffffff] tracking-tight'>
                    Spend Analysis
                  </p>
                  <div className='text-[14px] text-[#999999] mt-3'>
                    Gain valuable insights into expenditure patterns of your
                    team,
                    <br /> empowering strategic financial decision-making.
                  </div>
                  <div className='flex flex-row mt-6 justify-center'>
                    <img
                      src={AppImages.SPEND_ANALYSIS}
                      className='w-[343px] h-[149px] mr-3'
                    />
                  </div>
                </div>
                <div className='flex flex-col rounded-[16px] bg-[#F2F3F6] max-h-[442px] max-w-[448px] mt-6 lg:mt-0 lg:-order-1 border border-[#D1D1D1] lg:border-0'>
                  <p className='font-bold text-[#000000] tracking-tight mt-6 mx-6'>
                    Spend & Card Control
                  </p>
                  <div className='text-[14px] text-[#999999] mt-3 mx-6'>
                    Enable precise spend control with configurable limits,
                    allowing for effective and transparent financial management
                    across teams.
                  </div>
                  <div className='w-full flex flex-col items-end mt-[25px] mb-[32px]'>
                    <img
                      src={AppImages.SPEND_CARD_CONTROL}
                      className={'h-[268px] w-[390px] m-[-20px]'}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className='flex flex-col lg:flex-row items-center w-full justify-center mt-6 lg:mt-[152px]'>
              <img
                src={AppImages.WIRE_TRANSFER}
                className={'h-[422px] w-[398px] lg:mr-[72px]'}
              />
              <div className='flex flex-col lg:items-end justify-center px-4'>
                <p className='text-2xl lg:text-[44px] font-bold tracking-tighter lg:text-end'>
                  Global <span className='text-[#FFB900]'>Wire Transfer</span>
                </p>
                <p className='text-2xl lg:text-[44px] font-bold tracking-tighter lg:text-end lg:mt-4'>
                  & User Management{' '}
                </p>
                <p className='text-[#999999] mt-3 lg:text-end text-sm lg:text-base'>
                  Get unlimited cards for your team, both <br /> physical and
                  virtual card.
                </p>
              </div>
            </div>

            <div className='flex flex-col w-full items-center mt-6 lg:mt-[120px]'>
              <div className='flex lg:flex-row flex-col'>
                <div className='flex flex-col rounded-[16px] bg-[#141414] pb-8 overflow-hidden lg:mr-6 max-w-[328px] max-h-[335px]'>
                  <p className='font-bold text-[#ffffff] tracking-tight mt-6 px-6'>
                    Reimbursements
                  </p>
                  <div className='text-[14px] text-[#999999] mt-3 px-6'>
                    Reimburse team and vendors in <br /> USDC or fiat.
                  </div>
                  <div className='flex flex-row mt-6 justify-start mr-6'>
                    <img
                      src={AppImages.REIMBURSEMENTS}
                      className='w-[244px] h-[178px]'
                    />
                  </div>
                </div>
                <div className='flex flex-col rounded-[16px] bg-[#F2F3F6] overflow-hidden w-[328px] h-[452px] lg:w-[628px] lg:h-[335px] relative overflow-hidden mt-6 lg:mt-0 border border-[#D1D1D1] lg:border-0'>
                  <p className='font-bold text-[#000000] tracking-tight px-6 mt-6'>
                    Global Wire Transfer
                  </p>
                  <div className='text-[14px] text-[#999999] mt-3 mb-[32px] px-6'>
                    You can originate in USDC and pay your team members or
                    vendors in fiat and you can
                    <br /> initiate SWIFT wires, ACH transfers (US) and NEFT
                    payments (INR).
                  </div>
                  <div className='w-full flex flex-col items-center px-2'>
                    <img
                      src={AppImages.GLOBAL_WIRE_TRANSFER}
                      className={
                        'h-[341px] min-w-[640px] lg:mt-[-50px] m-[-20px] mb-[-32px] left-[13px] absolute'
                      }
                    />
                  </div>
                </div>
              </div>
              <div className='flex flex-col lg:flex-row mt-6'>
                <div className='flex flex-col rounded-[16px] bg-[#141414] p-6 pb-0 max-w-[328px] max-h-[335px] overflow-hidden'>
                  <p className='font-bold text-[#ffffff] tracking-tight'>
                    User Management
                  </p>
                  <div className='text-[14px] text-[#999999] mt-3'>
                    Efficiently oversee team expenses
                    <br /> across various platforms,
                    <br /> enhancing control and
                    <br /> optimization.
                  </div>
                  <div className='flex flex-row mt-4 justify-center'>
                    <img
                      src={AppImages.USER_MANAGEMENT}
                      className='w-[220px] h-[180px]'
                    />
                  </div>
                </div>

                <div className='flex flex-col rounded-[16px] bg-[#F2F3F6] w-[328px] h-[452px] lg:w-[628px] lg:h-[335px] relative overflow-hidden border border-[#D1D1D1] lg:mr-6 lg:-order-1 mt-6 lg:mt-0'>
                  <p className='font-bold text-[#000000] tracking-tight mt-6 mx-6'>
                    Stable Coin off ramp
                  </p>
                  <div className='text-[14px] text-[#999999] mt-3 mx-6'>
                    You can instantly convert your USDC to USD before funding
                    the corporate card or sending
                    <br /> out wire transfers.
                  </div>
                  <div className='w-full flex flex-col items-center'>
                    <img
                      src={AppImages.STABLE_COIN_OFF_RAMP}
                      className={
                        'min-w-[640px] h-[374px] lg:mt-[-50px] mx-[-20px] right-[13px] absolute mb-[20px]'
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className='flex flex-col items-center mt-[84px] lg:mt-[120px]'>
              <p className='text-[24px] lg:text-[44px] font-bold tracking-tighter text-left md:text-center'>
                Alerts And{' '}
                <span className='text-[#FFB900]'>Collaborative Tools</span>
                <br /> For Better Alignment{' '}
              </p>
            </div>

            <div className='flex flex-col lg:flex-row items-center lg:justify-center w-full mt-[84px] lg:mt-[120px] px-8'>
              <div className='flex flex-col items-center rounded-[16px] bg-[#F2F3F6] border border-[#D1D1D1] w-full max-w-[448px] max-h-[527px] lg:h-[527px] lg:mr-6 p-6 pb-0'>
                <p className='text-black font-bold w-full'>Alerts</p>
                <p className='text-[14px] text-[#999999] mt-3'>
                  Experience seamless transaction monitoring with alerts sent
                  directly via Telegram and webhooks
                </p>
                <img
                  src={AppImages.ALERTS}
                  className={
                    'max-w-[300px] max-h-[313px] lg:max-w-[400px] lg:max-h-[313px] lg:mt-[30px] lg:-mb-[10px]'
                  }
                />
              </div>
              <div className='flex flex-col items-center rounded-[16px] bg-[#F2F3F6] border border-[#D1D1D1] w-full max-w-[448px] max-h-[527px] lg:h-[527px] p-6 pb-0 mt-6 lg:mt-0'>
                <p className='text-black font-bold w-full'>Collaboration</p>
                <p className='text-[14px] text-[#999999] mt-3'>
                  Boost your team's financial synergy by annotating transactions
                  with comments and attachments, ensuring transparency and clear
                  communication.
                </p>
                <img
                  src={AppImages.COLLABORATION}
                  className={
                    'max-w-[276px] max-h-[376px] lg:max-w-[376px] lg:max-h-[376px] lg:mt-[45px] '
                  }
                />
              </div>
            </div>

            <div className='flex flex-col w-full items-center mt-[44px] lg:mt-[100px]'>
              <div className='flex flex-col w-[328px] lg:w-[920px] items-start mb-5'>
                <p className='text-2xl lg:text-[44px] text-[#A4A4A5] font-bold tracking-tighter'>
                  Coming Soon...
                </p>
              </div>
              <div className='flex flex-col rounded-[16px] bg-[#141414] p-6 lg:p-[40px] pb-0 w-[328px] h-[432px] lg:w-[920px] lg:h-[400px] relative overflow-hidden'>
                <p className='font-bold text-[#ffffff] tracking-tight'>
                  Accounting Integration
                </p>
                <div className='text-[14px] text-[#999999] mt-3'>
                  Sync blockchain/card spend with QuickBooks, Xero effortlessly.
                </div>
                <div className='flex flex-row mt-4 justify-center'>
                  <img
                    src={AppImages.ACCOUNT_INTEGRATION}
                    className='min-w-[832px] h-[293px] absolute left-[13px]'
                  />
                </div>
              </div>
            </div>
          </div>

          <div className='mt-12 lg:mt-32 w-full flex flex-col justify-center items-center'>
            <div className='w-full h-[1px] bg-[#EEEEEE]' />
            <div className='block md:hidden w-full h-[1px] bg-[#EEEEEE] mt-5 ' />
            <h1 className='text-2xl md:text-4xl font-bold text-center my-6 md:my-8'>
              Frequently Asked Questions
            </h1>
            <div className='block md:hidden w-full h-[1px] bg-[#EEEEEE] mb-5' />
            <div className='w-full h-[1px] bg-[#EEEEEE] ' />
            <div class='container px-6 mb-8 max-w-[920px] flex flex-col justify-center items-center mt-8 lg:mt-28'>
              <div className='w-full'>
                {businessFAQs.map((faq, index) => (
                  <div
                    key={index}
                    className={`p-8 rounded-2xl ${
                      expandedIndex === index ? 'bg-[#FFF9EA]' : ''
                    }`}
                  >
                    <div
                      className='flex justify-between items-center cursor-pointer'
                      onClick={() => toggleFAQ(index)}
                    >
                      <h2
                        className={`text-base md:text-2xl md:font-bold ${
                          expandedIndex === index
                            ? 'font-bold'
                            : 'formal-normal'
                        }`}
                      >
                        {faq.question}
                      </h2>
                      {expandedIndex === index && (
                        <IoIosArrowUp
                          className={'min-h-4 min-w-4 md:min-h-6 md:min-w-6'}
                        />
                      )}
                      {expandedIndex !== index && (
                        <IoIosArrowDown
                          className={'min-h-4 min-w-4 md:min-h-6 md:min-w-6'}
                        />
                      )}
                    </div>
                    {expandedIndex === index && (
                      <p className='mt-6 text-sm md:text-xl text-gray-600 font-normal'>
                        {faq.answer}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
